import PlanOfRecordLayout from "./layout/PlanOfRecordLayout";
import { PORContextProvider } from "../store/por-context";

export default function App() {
  return (
    <PORContextProvider>
      <PlanOfRecordLayout />
    </PORContextProvider>
  );
}